// extracted by mini-css-extract-plugin
module.exports = {"bottomQuotes":"FmM6x","logo":"yrm56","topQuotes":"_3tffI"};